var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContacts3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5122 23C34.5122 30 25.5122 36 25.5122 36C25.5122 36 16.5122 30 16.5122 23C16.5122 20.6131 17.4604 18.3239 19.1482 16.636C20.8361 14.9482 23.1253 14 25.5122 14C27.8992 14 30.1883 14.9482 31.8762 16.636C33.564 18.3239 34.5122 20.6131 34.5122 23Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 26C27.1691 26 28.5122 24.6569 28.5122 23C28.5122 21.3431 27.1691 20 25.5122 20C23.8554 20 22.5122 21.3431 22.5122 23C22.5122 24.6569 23.8554 26 25.5122 26Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.01221,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#A2A1A4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts3);
export default __webpack_public_path__ + "static/media/contacts_3.489613fa47fa6689a0189a18d2d6283d.svg";
export { ForwardRef as ReactComponent };